/**
 * Rótulos em português para Dose Certa (nunca exibir códigos EN na tela).
 */

/**
 * Data/hora — mesmo padrão da grade de Saídas (`versa/types/datetime.js`):
 * DD-MM-YYYY HH:MM:SS
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDateTimeBr(value)
{
	if (value == null || value === '')
		return '—';
	let s = String(value).trim();
	if (/^\d{4}-\d{2}-\d{2} /.test(s))
		s = s.replace(' ', 'T');
	const d = new Date(s);
	if (Number.isNaN(d.getTime()))
		return String(value);
	const pad = (n) => String(n).padStart(2, '0');
	return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/**
 * Só data: DD-MM-YYYY (alinhado ao padrão de Saídas)
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDateBr(value)
{
	if (value == null || value === '')
		return '—';
	let s = String(value).trim();
	if (/^\d{4}-\d{2}-\d{2}/.test(s) && !s.includes('T') && !s.includes(' '))
		s = `${s}T12:00:00`;
	else if (/^\d{4}-\d{2}-\d{2} /.test(s))
		s = s.replace(' ', 'T');
	const d = new Date(s);
	if (Number.isNaN(d.getTime()))
		return String(value).substring(0, 10);
	const pad = (n) => String(n).padStart(2, '0');
	return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}

const ESTEIRA_STATUS_PT = {
	PENDING: 'Pendente',
	SENT: 'Enviado',
	CHECKED: 'Conferido',
	ERROR: 'Erro',
};

/**
 * @param {object} row
 * @returns {string}
 */
export function labelEsteira(row)
{
	if (row?.exception_manual)
		return 'Coletor';
	const st = String(row?.sorter_status || '').trim().toUpperCase();
	if (st && ESTEIRA_STATUS_PT[st])
		return ESTEIRA_STATUS_PT[st];
	if (row?.sorter_mode)
		return '—';
	return 'Não';
}

/**
 * Traduz texto de filtro digitado (PT ou código) para match no valor bruto.
 * @param {string} value
 * @returns {string[]}
 */
export function esteiraFilterTokens(value)
{
	const v = String(value || '').trim().toLowerCase();
	if (!v) return [];
	const map = {
		pendente: ['pending'],
		enviado: ['sent'],
		conferido: ['checked'],
		erro: ['error'],
		coletor: ['manual', 'coletor'],
		manual: ['manual', 'coletor'],
		'não': ['off', 'nao', 'não'],
		nao: ['off', 'nao', 'não'],
		desligado: ['off'],
	};
	if (map[v]) return [v, ...map[v]];
	return [v];
}
